import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import {installClientLogger} from './utils/clientLogger';

import reportWebVitals from './reportWebVitals';

// Report errors and connection diagnostics to the server (see utils/clientLogger.js)
installClientLogger();

const root = ReactDOM.createRoot(document.getElementById('game-root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
